import React from 'react';

const Footer = () => {
    return (
        <div className="App mt-5">
            <p><b>Copyright © {new Date().getFullYear()}, Developed by Borshon Saha</b></p>
        </div>
    );
};

export default Footer;